module.exports = __webpack_public_path__ + "static/media/St-Lawrence-Rules-and-Regulations-2018.e14bf083.pdf";